import PublishPage from "./PublishPage";

export default PublishPage;